export default __webpack_public_path__ + "static/media/provesional_restoration_upper_33_2@2x.44aa808e.png";